import 'vite/modulepreload-polyfill';
import { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import Loader from './components/common/Loader';
import LazyBootstrap from './LazyBootstrap';
import './index.css';

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);

const element = (
    <Suspense fallback={<Loader />}>
        <LazyBootstrap />
    </Suspense>
);

root.render(element);
